import {EVERYONE_OPTION, PRIVATE_OPTION, TEAMS_OPTION} from "@irati/recognition/constants/share"
import {Recognition, RecognitionInput, SchedulerEventPublishRecognitionVisibility, User} from "@irati/types"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"
import momentTZ from "moment-timezone"
import {parseRecognition} from "../apollo/mutation/Recognition/Create"

interface ShareOption {
  label: string
  value: string
}
interface NewRecognition extends Omit<RecognitionInput, "userIds" | "teamIds"> {
  userIds: User[]
  teamIds: string[]
  share: ShareOption
  walletTransferId?: string
}

const parseScheduledRecognition = (recognition: NewRecognition, scheduleOptions: {date: string; timezone: string}): RecognitionInput => {
  return {
    ...parseRecognition(recognition),
    originalTimezone: scheduleOptions.timezone,
    scheduledAt: scheduleOptions.date ? scheduleOptions.date : momentTZ.tz(scheduleOptions.timezone)
  }
}

export const parseScheduledRecognitionToRecognition = (
  scheduledRecognition: Recognition,
  formatMessage: FormatMessage
): NewRecognition => {
  const recognitionVisibility = scheduledRecognition.visibility
  const defaultShare =
    recognitionVisibility === SchedulerEventPublishRecognitionVisibility.Teams
      ? TEAMS_OPTION(formatMessage)
      : recognitionVisibility === SchedulerEventPublishRecognitionVisibility.Private
        ? PRIVATE_OPTION(formatMessage)
        : EVERYONE_OPTION(formatMessage)
  return {
    share: defaultShare,
    isPrivate: recognitionVisibility === SchedulerEventPublishRecognitionVisibility.Private,
    userIds: scheduledRecognition.receivers?.results || [],
    teamIds: [],
    occasionId: scheduledRecognition.occasion?.uuid,
    companyValues: scheduledRecognition.companyValues?.results?.map(({uuid}) => uuid) || [],
    message: scheduledRecognition.message,
    rewardAmount: scheduledRecognition.rewardAmount,
    budget: scheduledRecognition.budget,
    customRewardId: scheduledRecognition.customRewardId,
    originalTimezone: scheduledRecognition.originalTimezone,
    scheduledAt: scheduledRecognition.scheduledAt,
  }
}
export default parseScheduledRecognition
